"use client";

import {
  TierSelectionCards,
  TournamentTier,
} from "@/components/ui/TierSelectionCards";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

export default function StartTournamentClient() {
  const t = useTranslations();
  const { user } = useAuth();
  const router = useRouter();

  const handleGetStarted = (tier: TournamentTier) => {
    // Require authentication
    if (!user) {
      const redirect = encodeURIComponent(
        `/start/create-organizer?tier=${tier}`,
      );
      router.push(`/login?redirect=${redirect}`);
      return;
    }

    // Existing organizers go straight to tournament creation with the picked tier
    if (user.organizerId && user.organizerSlug) {
      router.push(
        `/admin/${user.organizerSlug}/tournaments/new?tier=${tier}`,
      );
      return;
    }

    // New users create an organizer first
    router.push(`/start/create-organizer?tier=${tier}`);
  };

  return (
    <div className="flex flex-col items-center py-12 md:py-24 px-4">
      {/* Pricing Cards Grid */}
      <TierSelectionCards onSelect={handleGetStarted} tiers={["premium"]} />
      {/* Help Section */}
      <div className="text-center mt-12 md:mt-16">
        <div className="inline-flex items-center gap-2 text-muted">
          <Icon icon="solar:question-circle-bold-duotone" className="w-5 h-5" />
          <span className="font-spectral">{t("startTournament.needHelp")}</span>
          <Button
            as="a"
            href="mailto:mika@mikamika.fi"
            variant="light"
            size="sm"
            className="text-[var(--gold)] hover:text-[var(--gold-light)] font-cinzel px-2"
          >
            {t("startTournament.contactUs")}
          </Button>
        </div>
      </div>
    </div>
  );
}
